import DBHandler from "../index-db/db-handler";
import Sync from "./sync";
import { Sleep, genRanID } from "../utils/utils";
import { Wait_For_Auth } from "../utils/utils";
import { GLOBAL_VARS, NAV_CONTROL, SPORT_BASE, refresh_sport_base, SME_AUTH } from "./globalVars";
import { HotKeyController } from "../sport/class/coreSport";
import { clear_hot_load } from "../utils/game-utils";

var SERVICE_VAR = {
  id: null
}

const start_hotkey_listener = () => {
  try {
    if (typeof SPORT_BASE.store_sport_config !== 'undefined' && typeof SPORT_BASE.store_sport_config.hot_keys !== 'undefined') {
      // const hotKeyController = new HotKeyController({ sport_object: SPORT_BASE.sport_object }); 
      const hotKeyController = new HotKeyController(); 
      hotKeyController.register_hotkey_keys(SPORT_BASE.store_sport_config.hot_keys.keys);
      hotKeyController.register_hotkey_actions(SPORT_BASE.store_sport_config.hot_keys.actions);
      hotKeyController.start_listener();
    }
  } catch (error) {
    console.error('ERROR - ServiceLauncher - start_hotkey_listener: ', error);
  }
}


const ServiceLauncherHotLoad = () => {
  const init = async (loading_callback) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('>>> ServiceLauncherHotLoad <<<');

        // TODO needs a refactor - is a copy from ServiceLauncher
        if (SERVICE_VAR.id !== null) {
          return
        }
        SERVICE_VAR.id = genRanID();
        NAV_CONTROL.setAppLoading(true);
  
        const dbHandler = DBHandler();
        dbHandler.init();
        
        await SME_AUTH.init_without_auth('ServiceLauncherHotLoad');

        const syncObj = new Sync(SME_AUTH, {});
        if (typeof loading_callback === 'function') { loading_callback(true); }
        // await syncObj.init(); // TODO: Needs to be updated with host-loading support

        await syncObj.init_hot_load(); // TODO: Needs to be updated with host-loading support

        await Sleep(250);
        refresh_sport_base();
        await Sleep(250);

        // NAV_CONTROL.openMainMenuMatchHistory(); // 
        NAV_CONTROL.openMainMenuPushMatch();

        await Sleep(250);
        NAV_CONTROL.refreshScore();
        await Sleep(250);
        // NAV_CONTROL.openMainMenuNew();
        NAV_CONTROL.appliedDefaultSettings();
        
        NAV_CONTROL.setAppLoading(false);
        NAV_CONTROL.refreshScore();
        await Sleep(500);
        
        start_hotkey_listener();
        if (typeof loading_callback === 'function') { loading_callback(false); }
        console.log('>>>>>> ServiceLauncherHotLoad init completed <<<<<');

        // Initialize SyncTrigger
        const syncTrigger = new SyncTrigger(async () => {
          try {
            return await syncObj.sync_watch();
          } catch (error) {
            console.error('ERROR - ServiceLauncherHotLoad - Sync function: ', error);
            throw error;
          }
        });
        GLOBAL_VARS.syncTrigger = syncTrigger;
        console.log('[ServiceLauncherHotLoad] SyncTrigger initialized');

        // New sync loop using SyncTrigger
        do {
          await syncTrigger.runSync();
          const waitResult = await syncTrigger.waitForTrigger(20_000);
          console.log(`[ServiceLauncherHotLoad] Sync loop - Wait result: ${waitResult}`);
        } while (true);

        // OLD PATTERN - Kept for reference:
        // do {
        //   GLOBAL_VARS.last_sync_time = performance.now();
        //   try {
        //     await syncObj.sync_watch();
        //   } catch (error) {
        //     console.error('ERROR - ServiceLauncher - init - Sync Loop: ', error);
        //   }
        //   await re_sync_wait(10_000);
        // } while (true);
        
        
        resolve(true);
      } catch (error) {
        console.error('ERROR - ServiceLauncherHotLoad - init: ', error);
        resolve(false);
      }
    });
  }

  return { init }
}

const ServiceLauncher = () => {
  const init = async (loading_callback) => {
    return new Promise(async (resolve, reject) => {
      // console.log('>>> ServiceLauncher <<<');



      if (SERVICE_VAR.id !== null) {
        // console.warn('Killing Duplicate ServiceLauncher');
        return
      }
      SERVICE_VAR.id = genRanID();

      NAV_CONTROL.setAppLoading(true);

      await clear_hot_load();

      

      // console.log('-----SME_AUTH------: ', SME_AUTH);

      
      const dbHandler = DBHandler();
      dbHandler.init();
      // NAV_CONTROL.setAppLoading(false);
      await SME_AUTH.init('ServiceLauncher');
      // await Sleep(1500);
      await Wait_For_Auth(SME_AUTH, true);
      // NAV_CONTROL.setAppLoading(true);

      SME_AUTH.is_authenticated().then(async (authResult) => {
        // console.log('>>> Main authResult: ', authResult);
        if (authResult) {
          console.debug('%c [BACKEND - AUTH] >>> LOGGED IN <<<', 'background: #222; color: lightblue');
          // Start Auth Sync...
          const syncObj = new Sync(SME_AUTH, {});
          if (typeof loading_callback === 'function') { loading_callback(true); }
          await syncObj.init();

          // >>>  Refresh Sport Base
          await Sleep(250);
          refresh_sport_base();
          await Sleep(250);
          NAV_CONTROL.openMainMenuMatchHistory();
          await Sleep(250);
          NAV_CONTROL.refreshScore();
          await Sleep(250);
          NAV_CONTROL.openMainMenuNew();
          NAV_CONTROL.appliedDefaultSettings();
          // console.log('STOP LOADING');
          NAV_CONTROL.setAppLoading(false);
          NAV_CONTROL.refreshScore();
          await Sleep(500);

          // console.log('AAA: ', SPORT_BASE.sport_object);
          // if (typeof SPORT_BASE.store_sport_config !== 'undefined' && typeof SPORT_BASE.store_sport_config.hot_keys !== 'undefined') {
          //   // const hotKeyController = new HotKeyController({ sport_object: SPORT_BASE.sport_object }); 
          //   const hotKeyController = new HotKeyController(); 
          //   hotKeyController.register_hotkey_keys(SPORT_BASE.store_sport_config.hot_keys.keys);
          //   hotKeyController.register_hotkey_actions(SPORT_BASE.store_sport_config.hot_keys.actions);
          //   hotKeyController.start_listener();
          // }
          start_hotkey_listener();


          if (typeof loading_callback === 'function') { loading_callback(false); }
          
          // Initialize SyncTrigger
          const syncTrigger = new SyncTrigger(async () => {
            try {
              return await syncObj.sync_watch();
            } catch (error) {
              console.error('ERROR - ServiceLauncher - Sync function: ', error);
              throw error;
            }
          });
          GLOBAL_VARS.syncTrigger = syncTrigger;
          console.log('[ServiceLauncher] SyncTrigger initialized');

          // New sync loop using SyncTrigger
          do {
            await syncTrigger.runSync();
            const waitResult = await syncTrigger.waitForTrigger(20_000);
            console.debug(`[ServiceLauncher] Sync loop - Wait result: ${waitResult}`);
          } while (true);

          // OLD PATTERN - Kept for reference:
          // do {
          //   GLOBAL_VARS.last_sync_time = performance.now();
          //   try {
          //     await syncObj.sync_watch();
          //   } catch (error) {
          //     console.error('ERROR - ServiceLauncher - init - Sync Loop: ', error);
          //   }
          //   await re_sync_wait(10_000);
          //   console.error('re_sync_wait Returned')
          // } while (true);
        } else {
          console.error('Un expected Error - Auth Failed, Not logged int');
          // Start Offline Sync
        }

      }).catch((e) => {
        console.error('>>>>>>> Auth Check Crashed: ', e);
        resolve(false);
      });
      resolve(true);
    });
  }
  return { init }
}




// const re_sync_wait = (timeout = 5_000) => {
//   return new Promise(async (resolve, reject) => {
//     let kill_loop = false;
//     let timeout_id;
//     timeout_id = setTimeout(() => {
//       // console.log('[DEBUG-SYNC]re_sync_wait timeout');
//       kill_loop = true;
//       resolve(true);
//     }, timeout);
//     // let timestamp = performance.now();
//     do {
//       if (GLOBAL_VARS.last_sync_time > GLOBAL_VARS.matched_changed) { await Sleep(50); }
//       if (kill_loop) { return; }
//     } while (GLOBAL_VARS.last_sync_time > GLOBAL_VARS.matched_changed);
//     console.log('[DEBUG-SYNC] Quick Sync triggered');
//     clearTimeout(timeout_id);
//     resolve(true);
//   });
// }


const re_sync_wait = async (timeout = 5000) => {
  const start = Date.now();

  while (GLOBAL_VARS.last_sync_time > GLOBAL_VARS.matched_changed) {
    if (Date.now() - start > timeout) {
      // console.log('[DEBUG-SYNC] re_sync_wait timeout');
      return true;
    }
    await Sleep(50);
  }

  // console.log('[DEBUG-SYNC] Quick Sync triggered');
  return true;
};







// |---------  -|-  ---------| \\

class SyncTrigger {
  constructor(syncFunction) {
    if (typeof syncFunction !== 'function') {
      throw new Error('SyncTrigger requires a sync function');
    }
    this.syncFunction = syncFunction;
    this.waitingResolvers = []; // Array of resolve functions waiting for trigger
    this.pendingTriggerCount = 0; // Number of triggers that happened
    this.isCurrentlySyncing = false;
  }

  /**
   * Run the sync function
   * @returns {Promise} Result of sync function
   */
  async runSync() {
    this.isCurrentlySyncing = true;
    try {
      const result = await this.syncFunction();
      return result;
    } catch (error) {
      console.error('[SyncTrigger] Sync failed:', error);
      throw error;
    } finally {
      this.isCurrentlySyncing = false;
      
      // If triggers happened during sync, mark one as pending
      if (this.pendingTriggerCount > 0) {
        console.log(`[SyncTrigger] ${this.pendingTriggerCount} trigger(s) happened during sync`);
        // Don't reset to 0, leave it at current count so waitForTrigger exits immediately
      }
    }
  }

  /**
   * Wait for a trigger call OR timeout
   * Multiple triggers while waiting will only exit once
   * @param {number} timeout - Milliseconds to wait before timing out
   * @returns {Promise<string>} 'triggered' or 'timeout'
   */
  async waitForTrigger(timeout = 10_000) {
    // If there were pending triggers, consume them and exit immediately
    if (this.pendingTriggerCount > 0) {
      const count = this.pendingTriggerCount;
      this.pendingTriggerCount = 0; // Reset for next wait
      console.log(`[SyncTrigger] Immediately exiting wait - ${count} pending trigger(s)`);
      return 'triggered';
    }

    return new Promise((resolve) => {
      let timeoutId;
      let resolved = false;

      // Setup timeout
      timeoutId = setTimeout(() => {
        if (!resolved) {
          resolved = true;
          // Remove this resolver from waiting list
          const index = this.waitingResolvers.indexOf(resolveWrapper);
          if (index > -1) {
            this.waitingResolvers.splice(index, 1);
          }
          // console.log('[SyncTrigger] Wait timeout - syncing anyway');
          resolve('timeout');
        }
      }, timeout);

      // Wrapper to resolve and cleanup
      const resolveWrapper = (reason) => {
        if (!resolved) {
          resolved = true;
          clearTimeout(timeoutId);
          resolve(reason);
        }
      };

      // Add to waiting list
      this.waitingResolvers.push(resolveWrapper);
    });
  }

  /**
   * Trigger a sync to happen soon
   * If sync is running, queues trigger for after sync completes
   * If waiting, wakes up the wait immediately
   * Multiple simultaneous triggers coalesce into one
   */
  trigger(caller = '') {
    // console.error('-------------------------------- TRIGGERED --------------------------------');
    this.pendingTriggerCount++;
    
    if (this.isCurrentlySyncing) {
      // console.log(`[SyncTrigger] Trigger during sync (${this.pendingTriggerCount} pending)`);
      // Don't wake up waiters, just increment counter
      // The next waitForTrigger will see this and exit immediately
    } else if (this.waitingResolvers.length > 0) {
      // Wake up all waiting calls
      console.log(`[SyncTrigger] Trigger received - waking up ${this.waitingResolvers.length} waiter(s) - caller: ${caller}`);
      const resolvers = [...this.waitingResolvers];
      this.waitingResolvers = [];
      this.pendingTriggerCount = 0; // Reset since we're waking up now
      resolvers.forEach(resolve => resolve('triggered'));
    } else {
      // No one waiting, just increment counter
      // console.log(`[SyncTrigger] Trigger queued (${this.pendingTriggerCount} pending)`);
    }
  }

  /**
   * Check if a sync operation is currently in progress
   * @returns {boolean}
   */
  isRunning() {
    return this.isCurrentlySyncing;
  }

  /**
   * Get the number of pending triggers
   * @returns {number}
   */
  getPendingCount() {
    return this.pendingTriggerCount;
  }

  /**
   * Get the number of calls waiting for a trigger
   * @returns {number}
   */
  getWaitingCount() {
    return this.waitingResolvers.length;
  }
}

export default ServiceLauncher; 

export { 
  ServiceLauncher,
  ServiceLauncherHotLoad,
  SyncTrigger
}